var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 30.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #1a76cb;\r\n        stroke-linecap: round;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #6c88bc;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "preference_transfer-3",
    "data-name": "preference transfer-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6507-2",
    "data-name": "Group 6507-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6508",
    "data-name": "Group 6508"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8558-3",
    "data-name": "Path 8558-3",
    className: "cls-1",
    d: "M15.89,25.89l-3,2.99-2.98-2.99"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1228-3",
    "data-name": "Line 1228-3",
    className: "cls-1",
    x1: 12.9,
    y1: 27.36,
    x2: 12.9,
    y2: 22.41
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6497",
    "data-name": "Group 6497"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2547-5",
    "data-name": "Rectangle 2547-5",
    className: "cls-2",
    d: "M23,17.91h0c-1.66,0-3-1.34-3-3h0c0-1.66,1.34-3,3-3h0c1.66,0,3,1.34,3,3h0c0,1.66-1.34,3-3,3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6498",
    "data-name": "Group 6498"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2547-6",
    "data-name": "Rectangle 2547-6",
    className: "cls-2",
    d: "M3,17.91h0c-1.66,0-3-1.34-3-3h0c0-1.66,1.34-3,3-3h0c1.66,0,3,1.34,3,3h0c0,1.66-1.34,3-3,3Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8559",
    "data-name": "Path 8559",
    className: "cls-1",
    d: "M9.91,4.4l3-2.99,2.98,2.99"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1229",
    "data-name": "Line 1229",
    className: "cls-1",
    x1: 12.9,
    y1: 2.93,
    x2: 12.9,
    y2: 8.41
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveActive);
export default __webpack_public_path__ + "static/media/move-active.4704381040e122f182fcb4862bbf8041.svg";
export { ForwardRef as ReactComponent };